export default __webpack_public_path__ + "static/media/imc-inner-3.c9b0c5b8.jpg";